// extracted by mini-css-extract-plugin
export default {"pageWrap":"ld-z","fullWidth":"md-z","heading":"nd-z","fullBleed":"od-z","hidden":"pd-z"};